import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReversionService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getFusReversionesById(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'fusReversionesById/' + id, { headers: this.header(this.token) });
  }

  getFusReversionesPorModById(id: string, solicitudId: string): Observable<any> {    
    return this.http.get(this.baseUrl + 'fusReversionesPorModById/' + id + '/' + solicitudId, { headers: this.header(this.token) });
  }

  getFusModificacionesById(id: string, solicitudId: string): Observable<any> {    
    return this.http.get(this.baseUrl + 'fusModificacionesByIdFus/' + id + '/' + solicitudId, { headers: this.header(this.token) });
  }

  getListReversionesByIdFus(id: string): Observable<any> {
    return this.http.get(this.baseUrl + 'listReversionesByIdFus/' + id, { headers: this.header(this.token) });
  }

  postFusReversion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'fusReversion', bodyString, { headers: this.header(this.token) });
  }

  putFusReversion(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'putFusReversion', bodyString, { headers: this.header(this.token) });
  }

  anularFusPagoReversion(id: number, user_id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'deleteFusPagoReversion/' + id + '/' + user_id, { headers: this.header(this.token) });
  }

}
